import apiServices from "services/RequestHandler";

async function get_store(store_code: string) {
  try {
    if (!store_code) return;
    const storee = await apiServices.getFromApi(
      `/stores/all-public/${store_code}`,
      "store"
    );
    return storee;
  } catch (error) {
    console.error("Error fetching store:", error);
    throw error;
  }
}

/* eslint-disable no-restricted-globals */
self.onmessage = async function (e) {
  const { type, store_code } = e.data;
  let result;

  try {
    switch (type) {
      case "GET_STORE":
        result = await get_store(store_code);
        break;

      default:
        throw new Error("Unknown worker message type");
    }

    self.postMessage({ success: true, result });
  } catch (error: any) {
    self.postMessage({ success: false, error: error.message });
  }
};

export {};
